import {getActiveVariant, useAppDispatch, useAppSelector, setActiveVariant} from '@lib/store';
import {Variant} from '@lib/store/src/ui/usability/types';
import {useCallback, useEffect} from 'react';

const STORAGE_KEY = 'usability-variant';

export const useUsabilityVariant = () => {
  const activeVariant = useAppSelector(getActiveVariant);
  const dispatch = useAppDispatch();

  const setVariant = useCallback(
    (variant: Variant) => {
      if (variant === activeVariant) return;

      dispatch(setActiveVariant(variant));
      sessionStorage.setItem(STORAGE_KEY, variant);
    },
    [activeVariant, dispatch],
  );

  useEffect(() => {
    const storedVariant = sessionStorage.getItem(STORAGE_KEY) as Variant | null;
    setVariant(storedVariant ?? 'A');
  }, [setVariant]);

  return {
    activeVariant,
    setActiveVariant: setVariant,
  };
};
